import { render } from "./DocumentDropUpload.vue?vue&type=template&id=ed333096"
import script from "./DocumentDropUpload.vue?vue&type=script&lang=js"
export * from "./DocumentDropUpload.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__